import { Briefcase, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useViewModeStore } from '@/stores/view-mode';
import { useEmpresas } from '@/hooks/useEmpresa';

export function ViewModeSwitcher() {
  const { mode, setMode, previewEmpresaId, setPreviewEmpresaId } = useViewModeStore();
  const { data: empresas } = useEmpresas();
  const navigate = useNavigate();
  const isEmpresa = mode === 'empresa';

  const handleSelectEmpresa = (mode: 'consultor' | 'empresa') => {
    setMode(mode);
    if (mode === 'empresa' && previewEmpresaId !== null) {
      navigate(`/empresas/${previewEmpresaId}/feed`);
    }
  };

  const handleChangePreviewEmpresa = (id: number | null) => {
    setPreviewEmpresaId(id);
    if (id !== null) {
      navigate(`/empresas/${id}/feed`);
    }
  };

  return (
    <div className="flex items-center gap-2 xl:gap-3">
      <div
        role="group"
        aria-label="Seletor de visualização"
        className="flex h-10 items-center rounded-lg border border-ds-border bg-ds-surface2 p-1"
      >
        <button
          type="button"
          onClick={() => handleSelectEmpresa('consultor')}
          aria-pressed={!isEmpresa}
          className={`inline-flex h-8 items-center gap-1.5 rounded-md px-3 text-xs font-medium transition-colors ${
            !isEmpresa
              ? 'bg-ds-brand-subtle/30 text-ds-brand'
              : 'text-ds-text-secondary hover:text-ds-text-primary'
          }`}
        >
          <Briefcase className="h-3.5 w-3.5" />
          Consultor
        </button>
        <button
          type="button"
          onClick={() => handleSelectEmpresa('empresa')}
          aria-pressed={isEmpresa}
          className={`inline-flex h-8 items-center gap-1.5 rounded-md px-3 text-xs font-medium transition-colors ${
            isEmpresa
              ? 'bg-ds-brand-subtle/30 text-ds-brand'
              : 'text-ds-text-secondary hover:text-ds-text-primary'
          }`}
        >
          <Building2 className="h-3.5 w-3.5" />
          Empresa
        </button>
      </div>

      {isEmpresa && (
        <select
          aria-label="Empresa usada no preview da Visão Empresa"
          value={previewEmpresaId ?? ''}
          onChange={(e) => handleChangePreviewEmpresa(e.target.value ? Number(e.target.value) : null)}
          className="h-10 min-w-40 rounded-lg border border-ds-border bg-ds-surface2 px-2 text-xs text-ds-text-primary transition-colors focus:border-ds-brand focus:outline-none focus:ring-2 focus:ring-ds-brand/20 xl:min-w-48 xl:px-3"
        >
          <option value="">Selecione uma empresa…</option>
          {empresas?.map((empresa) => (
            <option key={empresa.id} value={empresa.id}>
              {empresa.nome_fantasia || empresa.razao_social}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
